export const singleElementOfArray = arr => {
  if (!arr) return arr;
  if (arr.length > 1) {
    console.error('The query returned an array with incorrect data');
  }
  return arr[0];
};